import { useEffect, useState } from 'react'

/**
 * True when the viewport is narrower than Tailwind's `lg` breakpoint.
 *
 * Deliberately a width query rather than user-agent sniffing, so a desktop browser in a
 * narrow window is treated the same as a phone. That is the right call for the polygon
 * drawing tool, where the constraint is available screen space, not the device.
 */
export function useIsSmallScreen(maxWidth = 1024) {
  const query = `(max-width: ${maxWidth - 1}px)`

  const [isSmall, setIsSmall] = useState(
    () => typeof window !== 'undefined' && window.matchMedia(query).matches,
  )

  useEffect(() => {
    const list = window.matchMedia(query)
    const onChange = (event: MediaQueryListEvent) => setIsSmall(event.matches)

    // Sync once on mount too: the viewport can change between render and effect.
    setIsSmall(list.matches)
    list.addEventListener('change', onChange)
    return () => list.removeEventListener('change', onChange)
  }, [query])

  return isSmall
}
